import dayjs from "dayjs";

export type PromoStatusCode = {
  codevalue?: string | number;
  codedisplayname?: string;
};

export function pickPromoExpiryRaw(item: Record<string, unknown>): unknown {
  return (
    item.expirydate ??
    item.expiryDate ??
    item.enddate ??
    item.endDate ??
    item.validto ??
    item.validTo
  );
}

/** True when expiry is not still in the future (today or earlier → show Expired). */
export function isPromoExpiredByExpiryDate(
  item: Record<string, unknown>,
): boolean {
  const raw = pickPromoExpiryRaw(item);
  if (raw == null || String(raw).trim() === "") return false;
  const expiry = dayjs(String(raw).trim());
  if (!expiry.isValid()) return false;
  return !expiry.startOf("day").isAfter(dayjs().startOf("day"));
}

export function statusCodeValueFromApi(item: Record<string, unknown>): string {
  const raw = item.status ?? item.promoStatus ?? item.promostatus;
  if (raw === undefined || raw === null) return "";
  return String(raw).trim();
}

/** API status, or Expired code when expiry date is today or in the past. */
export function resolvePromoStatusCodeValue(
  item: Record<string, unknown>,
  expiredStatusCodeValue?: string,
): string {
  if (expiredStatusCodeValue && isPromoExpiredByExpiryDate(item)) {
    return expiredStatusCodeValue;
  }
  return statusCodeValueFromApi(item);
}

export function findExpiredPromoStatusCodeValue(
  promoStatusCodes: PromoStatusCode[],
): string | undefined {
  const match = promoStatusCodes.find((c) =>
    /expir/i.test(String(c.codedisplayname ?? "")),
  );
  if (match?.codevalue == null || String(match.codevalue).trim() === "") {
    return undefined;
  }
  return String(match.codevalue).trim();
}
